"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var BaseFirebaseDB = require("./BaseFirebaseDB");
var axios = require("axios");
module.exports = /*#__PURE__*/function (_BaseFirebaseDB) {
  (0, _inherits2["default"])(FirebaseAPI, _BaseFirebaseDB);
  var _super = _createSuper(FirebaseAPI);
  function FirebaseAPI(firebase, pathConfig, baseUrl, plainToClassHook, classToPlainHook, classTransformOptions) {
    var _this;
    (0, _classCallCheck2["default"])(this, FirebaseAPI);
    _this = _super.call(this, pathConfig, plainToClassHook, classToPlainHook, classTransformOptions);
    _this.baseUrl = baseUrl;
    _this.auth = firebase.auth();
    _this.setupAxiosDebug();
    return _this;
  }
  (0, _createClass2["default"])(FirebaseAPI, [{
    key: "apiFetch",
    value: function apiFetch(path, params, clazz, options) {
      var _this2 = this;
      return this.get(path, params).then(function (data) {
        return clazz ? _this2.plainToClassHook(clazz, data, options) : data;
      }).then(function (data) {
        return _this2.logData(data, path);
      });
    }
  }, {
    key: "apiDownload",
    value: function apiDownload(path, params, clazz, options) {
      var _this3 = this;
      return this.download(path, params).then(function (data) {
        return clazz ? _this3.plainToClassHook(clazz, data, options) : data;
      }).then(function (data) {
        return _this3.logData(data, path);
      });
    }
  }, {
    key: "apiPost",
    value: function apiPost(path, object, clazz, options) {
      var _this4 = this;
      return this.post(path, object).then(function (data) {
        return clazz ? _this4.plainToClassHook(clazz, data, options) : data;
      }).then(function (data) {
        return _this4.logData(data, path);
      });
    }
  }, {
    key: "apiDelete",
    value: function apiDelete(path, object, clazz, options) {
      var _this5 = this;
      return this["delete"](path, object).then(function (data) {
        return clazz ? _this5.plainToClassHook(clazz, data, options) : data;
      }).then(function (data) {
        return _this5.logData(data, path);
      });
    }
  }, {
    key: "generateId",
    value: function generateId() {
      throw new Error("generateId not implemented");
    }
  }, {
    key: "setupAxiosDebug",
    value: function setupAxiosDebug() {
      var _this6 = this;
      if (this.isDebugEnabled) {
        axios.interceptors.request.use(function (request) {
          _this6.log('Starting Request', request);
          return request;
        });
        axios.interceptors.response.use(function (response) {
          _this6.log('Response:', response);
          return response;
        });
      }
    }
  }, {
    key: "getAbsoluteUrl",
    value: function getAbsoluteUrl(relativeUrl) {
      if (!this.baseUrl) {
        throw new Error("BaseFirebaseAPI: baseUrl not set. Please provide baseUrl in constructor");
      }
      return this.baseUrl + "/" + relativeUrl;
    }
  }, {
    key: "post",
    value: function post(url, data, forceRefresh) {
      this.log("url = ", url, ", data = ", data);
      return this.postAbsolute(this.getAbsoluteUrl(url), data, forceRefresh);
    }
  }, {
    key: "get",
    value: function get(url, data, forceRefresh) {
      return this.getAbsolute(this.getAbsoluteUrl(url), data, forceRefresh);
    }
  }, {
    key: "download",
    value: function download(url, data, forceRefresh) {
      return this.downloadAbsolute(this.getAbsoluteUrl(url), data, forceRefresh);
    }
  }, {
    key: "delete",
    value: function _delete(url, data, forceRefresh) {
      return this.deleteAbsolute(this.getAbsoluteUrl(url), data, forceRefresh);
    }
  }, {
    key: "postAbsolute",
    value: function postAbsolute(url, data, forceRefresh) {
      var _this7 = this;
      return this.createAuthHeader(forceRefresh).then(function (headers) {
        return axios.post(url, data, {
          headers: headers
        });
      }).then(function (response) {
        return _this7.responseToData(response, url);
      });
    }
  }, {
    key: "getAbsolute",
    value: function getAbsolute(url, data, forceRefresh) {
      var _this8 = this;
      return this.createAuthHeader(forceRefresh).then(function (headers) {
        return axios.get(url, {
          headers: headers,
          params: data
        });
      }).then(function (response) {
        return _this8.responseToData(response, url);
      });
    }
  }, {
    key: "downloadAbsolute",
    value: function () {
      var _downloadAbsolute = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url, data, forceRefresh) {
        var headers, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.createAuthHeader(forceRefresh);
            case 2:
              headers = _context.sent;
              headers["Content-Disposition"] = "attachment";
              _context.next = 6;
              return axios.get(url, {
                headers: headers,
                params: data,
                responseType: "blob"
              });
            case 6:
              response = _context.sent;
              return _context.abrupt("return", this.responseToData(response, url));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function downloadAbsolute(_x, _x2, _x3) {
        return _downloadAbsolute.apply(this, arguments);
      }
      return downloadAbsolute;
    }()
  }, {
    key: "deleteAbsolute",
    value: function deleteAbsolute(url, data, forceRefresh) {
      var _this9 = this;
      return this.createAuthHeader(forceRefresh).then(function (headers) {
        return axios["delete"](url, {
          headers: {
            headers: headers
          },
          data: data,
          maxContentLength: 10000
        });
      }).then(function (response) {
        return _this9.responseToData(response, url);
      });
    }
  }, {
    key: "responseToData",
    value: function responseToData(response, url) {
      var data = response.data || null;
      return data;
    }
  }, {
    key: "logData",
    value: function logData(data, url) {
      this.log("FirebaseAPI response: data = ", data, ", path = ", url);
      return data;
    }
  }, {
    key: "createAuthHeader",
    value: function createAuthHeader(forceRefresh) {
      return this.getUserToken(forceRefresh).then(function (token) {
        var auth = {
          'Authorization': 'Bearer ' + token
        };
        return auth;
      })["catch"](function (error) {
        return {};
      });
    }
  }, {
    key: "getUserToken",
    value: function () {
      var _getUserToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var forceRefresh,
          _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              forceRefresh = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : true;
              _context2.next = 3;
              return this.auth.currentUser.getIdToken(forceRefresh);
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getUserToken() {
        return _getUserToken.apply(this, arguments);
      }
      return getUserToken;
    }()
  }]);
  return FirebaseAPI;
}(BaseFirebaseDB);